import { Amplify } from 'aws-amplify';
import { SerializableAWSConfig } from '../config/aws';
import { LoginType } from '../api-types/models/LoginDto';

// Store login type to localStorage to define user pool for logged in users
export function setConfig(loginType: LoginType, config: SerializableAWSConfig) {
    localStorage.setItem('login', loginType);
    const authConfig =
        loginType === LoginType.BRUNCH || loginType === LoginType.COACH
            ? config.Auth.users
            : undefined;
    if (authConfig) {
        Amplify.configure({
            Auth: {
                Cognito: {
                    userPoolId: authConfig.userPoolId ?? '',
                    userPoolClientId: authConfig.userPoolWebClientId ?? '',
                    loginWith: {
                        oauth: {
                            domain: authConfig.oauth.domain ?? '',
                            scopes: authConfig.oauth.scope,
                            redirectSignIn: [
                                authConfig.oauth.redirectSignIn ?? ''
                            ],
                            redirectSignOut: [
                                authConfig.oauth.redirectSignOut ?? ''
                            ],
                            responseType: 'code'
                        }
                    }
                }
            }
        });
    }
}
